<section class="officialized">
    <section class="left-container">
        <h2>Muitas cidades já oficializaram o Dia de Doar, por meio de lei, como uma data local a ser celebrada</h2>
        <p>
            A oficialização, sozinha, não tem significado prático - a não ser entrar no calendário local de
            comemorações.
            Mas ela é importante para dar credibilidade ao movimento, e também inspirar outros atores a se engajarem na
            iniciativa, além de proporcionar também envolver a administração pública nela.
        </p>
        <p>
            Se você pensa em estimular a Câmara Municipal (ou mesmo a Assembleia Legislativa do seu Estado) a levar
            adiante
            o reconhecimento do Dia de Doar, preparamos um modelo de Projeto de Lei para ser utilizado com o
            representante
            no legislativo que você tenha contato.
        </p>
    </section>

    <section class="right-container">
        <div class="map-wrapper" *ngIf="apiLoaded | async">
            <google-map [center]="center" [zoom]="zoom" [height]="'520px'" [width]="'100%'" 
                (zoomChanged)="onZoomChanged()">

                <ng-container *ngIf="cities?.length">
                    <map-marker *ngFor="let city of cities" [position]="{ lat: city.lat, lng: city.lng }"
                        [options]="markerOptions">
                    </map-marker>
                </ng-container>
            </google-map>
        </div>
    </section>
</section>


<section class="city-list">
    <mat-grid-list cols="6" rowHeight="4:1">
        <ng-container *ngFor="let city of cities">
            <mat-grid-tile>
                <a class="city-link" [href]="city.url" target="_blank" rel="noopener noreferrer">
                    {{ city.movimento || city.nome }}
                </a>
            </mat-grid-tile>
        </ng-container>
    </mat-grid-list>
</section>